import {Component, EventEmitter, forwardRef, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {TramiteRequisitoRq} from "../../../../users/tramites/components/interfaces/tramites.interface";
import {NgClass, NgIf, NgStyle, NgTemplateOutlet} from "@angular/common";
import {InputGroupModule} from "primeng/inputgroup";
import {FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";
import {InputTextModule} from "primeng/inputtext";
import {TooltipModule} from "primeng/tooltip";

@Component({
    selector: 'rq-text',
    standalone: true,
    imports: [
        NgIf,
        NgClass,
        NgStyle,
        InputGroupModule,
        FormsModule,
        InputTextModule,
        TooltipModule,
        NgTemplateOutlet
    ],
    templateUrl: './rq-text.html',
    styleUrl: './rq-text.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RqText),
            multi: true
        }
    ]
})
export class RqText implements OnInit {
    @Input() rq!: TramiteRequisitoRq;
    @Input() onSubmitTemplate!: TemplateRef<any | null>;
    @Output() onSubmitEmitter = new EventEmitter<{ rq: TramiteRequisitoRq, event: Event }>();

    constructor() {
    }

    ngOnInit() {
        console.log(`ngOnInit() ->` + this.constructor.name)
    }

    onSubmitClicked(rq: TramiteRequisitoRq, event: Event) {
        this.onSubmitEmitter.emit({rq, event});
    }
}
